import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export const getH3Content = (Component: React.ReactNode) => {
  if (!Component) return null;

  const h3Regex = /<h3 id="(.*?)">(.*?)<\/h3>/;
  // @ts-ignore
  const componentHtml = renderToStaticMarkup(Component);
  const h3Match = componentHtml.match(h3Regex);
  if (h3Match && h3Match.length > 2) {
    return [h3Match[1], h3Match[2]];
  }
  return null;
};
